__turbopack_context__.v({
  "annotation": "SyvMtq_annotation",
  "block": "SyvMtq_block",
  "button": "SyvMtq_button",
  "content": "SyvMtq_content",
  "hidden": "SyvMtq_hidden",
  "icon": "SyvMtq_icon",
  "iconCheck": "SyvMtq_iconCheck",
  "isRollup": "SyvMtq_isRollup",
  "item": "SyvMtq_item",
  "itemClassLink": "SyvMtq_itemClassLink",
  "list": "SyvMtq_list",
  "listTitle": "SyvMtq_listTitle",
  "title": "SyvMtq_title",
});
